import { ReactNode } from 'react';

import { useMatch } from 'react-router-dom';

import { WithLayout } from '../../RetailApp/components/WithLayout';

export function InferLayout({ children }: { children: ReactNode }) {
  const home = useMatch('/checking/accounts/:accountId');
  const transactions = useMatch('/checking/accounts/:accountId/transactions');
  const hasSidebar = Boolean(home || transactions);

  return <WithLayout parts={{ sidebar: hasSidebar, footer: true }}>{children}</WithLayout>;
}
